import { Expose } from 'class-transformer';

import { SnShareDirection } from './share-direction';
import { SnSharePermissions } from './share-permissions';
import { SnSharePermissionsDetails } from './share-permissions-details';

export class SnShareInfo {
  @Expose()
  public id: string;

  @Expose()
  public permissions: SnSharePermissions;

  @Expose()
  public permissionsDetails: SnSharePermissionsDetails;

  @Expose()
  public direction: SnShareDirection;

  @Expose()
  public isRestricted: boolean;

  @Expose()
  public settings: any;

  constructor() {}
}
